import { MsalAccountRepository } from './msal-account.repository';

export * from './msal-account.repository';

export const SecurityRepositoryServices = [
    MsalAccountRepository,
];
